// extracted by mini-css-extract-plugin
export default {"customTable":"Grid_customTable__D1Ty5"};